import React from 'react'
import styled from 'styled-components'
import BlockOutput from 'content-renderer'
import { Typography } from 'common/typography'
import { useCourse } from 'querys/course'

const CourseRequirementsStyled = styled.section`
  font: var(--regular);
  a {
    color: var(--turquoise);
    text-decoration: underline;
  }
`

function CourseRequirements() {
  const { data: { requirements: { blocks } } } = useCourse()
  return (
    <CourseRequirementsStyled aria-labelledby="requirements">
      <div>
        <Typography small="headline5" large="headline6" color="var(--baseNeutral)" id="requirements">
          Requisitos
        </Typography>
        {blocks && (
          <BlockOutput
            color="var(--paragraphColor)"
            success
            chunks={blocks}
          />
        )}
      </div>
    </CourseRequirementsStyled>
  )
}

export default CourseRequirements
